<template>
  <div>
    <AdminTableContainer
      :users="localUsers"
      :headers="headers"
      :options="options" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AdminTableContainer from '../../components/AdminTableContainer'

export default {
  name: 'DietitianMgmt',
  components: { AdminTableContainer },
  data() {
    return {
      headers: ['name', 'clients', 'email', 'phone'],
      localUsers: {},
      options: {
        sortable: true,
        showClients: true
      }
    }
  },
  methods: {
    ...mapActions(['getNutritionists'])
  },
  computed: {
    ...mapGetters(['dietitians'])
  },
  mounted: async function() {
    await this.getNutritionists({})
    this.localUsers = this.dietitians
  },
  watch: {
    dietitians: {
      handler: function () {
        this.localUsers = this.dietitians
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/Pages/DietitianMgmt/DietitianMgmt.vue?1be3a8bd